import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconButton } from '@calendly/ui/components/icon-button';
import { DeleteIcon, MailSendEnvelopeIcon, SettingsMenuVerticalIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { openRemoveInvitationsPopup, resendInvitation } from './slice';
const styledItemCss = "sqdxqa5";
const StyledItem = forwardRef((props, ref) => <Item ref={ref} {...props} className={classNames(styledItemCss, props.className)} />);
const actionsCss = "a1jkbuts";
const Actions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(actionsCss, props.className)} />;
});
export const ActionsDropdown = ({
  invitation
}) => {
  const dispatch = useDispatch();
  const [toggle, Dropdown, isExpanded] = useDropdown();
  const enforceUpgrade = useEnforceUpgrade('organization_invitation', {
    skipPreface: true
  });
  const handleResend = () => enforceUpgrade(() => dispatch(resendInvitation(invitation.id)));
  return <Actions>
      <IconButton size="small" aria-expanded={isExpanded} title={I18n.t('publisher.components.table.action_menu_for', {
      item: invitation.email
    })} onClick={toggle}>
        <SettingsMenuVerticalIcon />
      </IconButton>
      <Dropdown>
        <ViewportDropdownMenu>
          {invitation.policy.destroy && <StyledItem onClick={() => dispatch(openRemoveInvitationsPopup(invitation))}>
              <DeleteIcon />
              {I18n.t('publisher.action.remove')}
            </StyledItem>}
          {invitation.policy.resend && <StyledItem onClick={() => handleResend()}>
              <MailSendEnvelopeIcon />
              {I18n.t('publisher.organization.members.resend_invite')}
            </StyledItem>}
        </ViewportDropdownMenu>
      </Dropdown>
    </Actions>;
};

require("./actions_dropdown.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./actions_dropdown.js");